import BibliographiesContainer from './BibliographiesContainer';

export default { BibliographiesContainer };
